import { Action } from '@ngrx/store';
import { QueryParamsModel } from '../../_base/crud';
import { RelationshipCategory } from '../_models/relationship-category.model';

export enum RelationshipCategoryActionTypes {
  RelationshipCategoryOnServerDeleted = '[RelationshipCategory] RelationshipCategory On Server Deleted',
  RelationshipCategoryDeleted = '[RelationshipCategory] RelationshipCategory Deleted',
  RelationshipCategoryPageRequested = '[RelationshipCategory] RelationshipCategory Page Requested',
  RelationshipCategoryPageLoaded = '[RelationshipCategory] RelationshipCategory Page Loaded',
  RelationshipCategoryPageCancelled = '[RelationshipCategory] RelationshipCategory Page Cancelled',
  RelationshipCategoryPageToggleLoading = '[RelationshipCategory] RelationshipCategory Page Toggle Loading',
  RelationshipCategoryActionToggleLoading = '[RelationshipCategory] RelationshipCategory Action Toggle Loading',
  ThrowRelationshipCategoryError = '[RelationshipCategory] Throw Error',
  FireRelationshipCategorySuccess = '[RelationshipCategory] Fire Success',
}

export class ThrowRelationshipCategoryError implements Action {
  readonly type = RelationshipCategoryActionTypes.ThrowRelationshipCategoryError;

  constructor(public payload: { error: any }) {}
}

export class FireRelationshipCategorySuccess implements Action {
  readonly type = RelationshipCategoryActionTypes.FireRelationshipCategorySuccess;

  constructor(public payload: { action_type: string }) {}
}

export class RelationshipCategoryOnServerDeleted implements Action {
  readonly type = RelationshipCategoryActionTypes.RelationshipCategoryOnServerDeleted;

  constructor(public payload: { id: number }) {}
}

export class RelationshipCategoryDeleted implements Action {
  readonly type = RelationshipCategoryActionTypes.RelationshipCategoryDeleted;

  constructor(public payload: { id: number }) {}
}

export class RelationshipCategoryPageRequested implements Action {
  readonly type = RelationshipCategoryActionTypes.RelationshipCategoryPageRequested;

  constructor(public payload: { page: QueryParamsModel }) {}
}

export class RelationshipCategoryPageLoaded implements Action {
  readonly type = RelationshipCategoryActionTypes.RelationshipCategoryPageLoaded;

  constructor(
    public payload: {
      relationshipCategory: RelationshipCategory[];
      totalCount: number;
      page: QueryParamsModel;
    },
  ) {}
}

export class RelationshipCategoryPageCancelled implements Action {
  readonly type = RelationshipCategoryActionTypes.RelationshipCategoryPageCancelled;
}

export class RelationshipCategoryPageToggleLoading implements Action {
  readonly type = RelationshipCategoryActionTypes.RelationshipCategoryPageToggleLoading;

  constructor(public payload: { isLoading: boolean }) {}
}

export class RelationshipCategoryActionToggleLoading implements Action {
  readonly type = RelationshipCategoryActionTypes.RelationshipCategoryActionToggleLoading;

  constructor(public payload: { isLoading: boolean }) {}
}

export type RelationshipCategoryActions =
  | RelationshipCategoryDeleted
  | RelationshipCategoryOnServerDeleted
  | RelationshipCategoryPageLoaded
  | RelationshipCategoryPageCancelled
  | RelationshipCategoryPageToggleLoading
  | RelationshipCategoryPageRequested
  | ThrowRelationshipCategoryError
  | FireRelationshipCategorySuccess
  | RelationshipCategoryActionToggleLoading;
